import { isObject } from 'lodash';

export type AdditionalProductRenderOptions = {
    withDescription: {
        inPreview: boolean;
        inDetail: boolean;
        inStore: boolean;
    };
};

const DEFAULT_ADDITIONAL_PRODUCT_RENDER_OPTIONS: AdditionalProductRenderOptions =
    {
        withDescription: {
            inPreview: false,
            inDetail: true,
            inStore: true,
        },
    };

export const sanitizeAdditionalProductConfig = (
    config: unknown
): AdditionalProductRenderOptions => {
    if (!isObject(config)) return DEFAULT_ADDITIONAL_PRODUCT_RENDER_OPTIONS;

    if (!('withDescription' in config) || !isObject(config.withDescription)) {
        return DEFAULT_ADDITIONAL_PRODUCT_RENDER_OPTIONS;
    }

    return {
        withDescription: {
            inPreview:
                'inPreview' in config.withDescription &&
                typeof config.withDescription.inPreview === 'boolean'
                    ? config.withDescription.inPreview
                    : DEFAULT_ADDITIONAL_PRODUCT_RENDER_OPTIONS.withDescription
                          .inPreview,
            inDetail:
                'inDetail' in config.withDescription &&
                typeof config.withDescription.inDetail === 'boolean'
                    ? config.withDescription.inDetail
                    : DEFAULT_ADDITIONAL_PRODUCT_RENDER_OPTIONS.withDescription
                          .inDetail,
            inStore:
                'inStore' in config.withDescription &&
                typeof config.withDescription.inStore === 'boolean'
                    ? config.withDescription.inStore
                    : DEFAULT_ADDITIONAL_PRODUCT_RENDER_OPTIONS.withDescription
                          .inStore,
        },
    };
};
